import request from '@/common/request.js'
export function getInfo () {
  return request.get('/quote/user/info')
}

